import api from './api'

const servicesBasePath = '/api/v1/service'

export async function listServices() {
  const resp = await api.get(`${servicesBasePath}`)
  return resp.data
}

export async function reorderService(list) {
  const resp = await api.patch(`${servicesBasePath}/reorder`, list)
  return resp.data
}

export async function createService(service) {
  const resp = await api.post(servicesBasePath, service)
  return resp.data
}

export async function editService(service, id) {
  const resp = await api.patch(`${servicesBasePath}/${id}`, service)
  return resp.data
}

export async function getService(id) {
  const resp = await api.get(`${servicesBasePath}/${id}`)
  return resp.data
}

export async function deleteService(id) {
  const resp = await api.delete(`${servicesBasePath}/${id}`)
  return resp.data
}
